import { Button, Modal } from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import 'react-medium-image-zoom/dist/styles.css'
import axios from "axios";
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import NsModalHeader from "../../../components/modal/NsModalHeader";
import Translate from "../../../components/Translate";
import NsDatePicker from "../../../components/NsDatePicker";
import { convertiDateInDataPerDb } from "../../../utility/common";
import {LoaderContext} from "../../../context/LoaderContext";
import {getDocumentoArchivioByIdApi} from "../services/ArchivioServices";

// Registrazione plugins
registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginFileValidateType
);


export default function ModalDocumentoArchivio({
                                                   idDocumento,
                                                   show,
                                                   handleClose,
                                                   titolo,
                                                   tema,
                                                   sottotema,
                                                   submitOk,
                                                   labelAdd,
                                               }) {

    const [files, setFiles] = useState([]);
    const [anteprime, setAnteprime] = useState([]);
    const [titoloDoc, setTitoloDoc] = useState('');
    const [soggetto, setSoggetto] = useState('');
    const [formato, setFormato] = useState('');
    const [tipo, setTipo] = useState('');
    const [dataDoc, setDataDoc] = useState(null);
    const [annoDoc, setAnnoDoc] = useState('');
    const [note, setNote] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    // Reset completo allo stato iniziale
    const resetState = () => {
        setFiles([]);
        setTitoloDoc('');
        setSoggetto('');
        setFormato('');
        setAnnoDoc('');
        setTipo('');
        setNote('');
        setDataDoc(null);
        setIsSaving(false);
    };

    // Funzione per gestire il salvataggio manuale
    const handleSave = async () => {
        if (!titoloDoc) {
            alert("Il campo Titolo è obbligatorio.");
            return;
        }
        if (!idDocumento && files.length === 0) {
            alert("Devi selezionare almeno un file.");
            return;
        }
        if (tema.sottotemi && tema.sottotemi !== '' && tipo === '') {
            alert("Devi selezionare un tipo.");
            return;
        }

        // Mostra feedback di caricamento
        setIsSaving(true);

        const formData = new FormData();
        formData.append('titolo', titoloDoc);
        formData.append('soggetto', soggetto);
        formData.append('formato', formato);
        formData.append('tipo', tipo);
        formData.append('anno_doc', annoDoc);
        formData.append('data_doc', dataDoc ? convertiDateInDataPerDb(dataDoc) : '');
        formData.append('note', note);

        files.forEach(fileItem => {
            formData.append('files', fileItem.file);
        });
        anteprime.forEach(anteprimaItem => {
            formData.append('anteprime', anteprimaItem.file);
        });

        try {
            if (idDocumento) {
                // Modifica documento

                // Sono obbligato ad utilizzare il verbo POST perché la PUT non accetta 'multipart/form-data'
                await axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/documenti/${idDocumento}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                });
            } else {
                // Aggiungi documento

                await axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli/${titolo?.id_archivio_titolo}/temi/${tema?.id_archivio_tema}/documenti/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            }

            submitOk();
            handleClose();
        } catch (error) {
            console.error("Upload failed:", error.response ? error.response.data : error.message);
            // Mostra un messaggio di errore all'utente
            alert("Errore durante il caricamento del file. Riprova.");
        } finally {
            setIsSaving(false);
        }
    };

    async function getDocumento() {
        startChiamata();
        const response = await getDocumentoArchivioByIdApi(idDocumento);
        endChiamata();

        let dati = response.data.data;
        if (dati) {
            setTitoloDoc(dati.titolo);
            setSoggetto(dati.soggetto);
            setFormato(dati.formato);
            setTipo(dati.tipo);
            setAnnoDoc(dati.anno_doc);
            setNote(dati.note);
            setDataDoc(dati.data_doc);
        }
    }

    useEffect(() => {
        resetState();
        if (sottotema && sottotema !== '') {
            setTipo(sottotema);
        }
        if (idDocumento && idDocumento !== '') {
            getDocumento();
        }
    }, [idDocumento]);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size={"xl"}
        >
            <NsModalHeader title={labelAdd} />
            <Modal.Body>
                <div className={"row g-3"}>
                    <div className={"col-md-6"}>
                        <label htmlFor="titolo" className="form-label">Titolo*:</label>
                        <input
                            type={"text"}
                            id={"titolo"}
                            name={"titolo"}
                            className={"form-control"}
                            value={titoloDoc}
                            onChange={(ev) => setTitoloDoc(ev.target.value)}
                            required
                        />
                    </div>
                    {
                        tema.sottotemi && tema.sottotemi !== '' &&
                        <div className={"col-md-6"}>
                            <label htmlFor="tipo" className="form-label">Tipo*:</label>
                            <select
                                id={"tipo"}
                                name={"tipo"}
                                className={"form-control form-select"}
                                value={tipo}
                                onChange={(ev) => setTipo(ev.target.value)}
                                required
                                disabled={sottotema && sottotema !== ''}
                            >
                                <option value={""}></option>
                                {
                                    tema.sottotemi.split(';').map((st, idx) =>
                                        <option key={idx} value={st}>{st}</option>
                                    )
                                }
                            </select>
                        </div>
                    }
                    <div className={"col-md-6"}>
                        <label htmlFor="soggetto" className="form-label">Soggetto proprietario:</label>
                        <input
                            type={"text"}
                            id={"soggetto"}
                            name={"soggetto"}
                            className={"form-control"}
                            value={soggetto}
                            onChange={(ev) => setSoggetto(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="formato" className="form-label">Formato e caratteristiche materiali:</label>
                        <input
                            type={"text"}
                            id={"formato"}
                            name={"formato"}
                            className={"form-control"}
                            value={formato}
                            onChange={(ev) => setFormato(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="dataDoc" className="form-label">Data documento:</label>
                        <NsDatePicker
                            nome={"dataDoc"}
                            dataSelezionata={dataDoc}
                            setSelectedDate={(date) => setDataDoc(date)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="formato" className="form-label">Anno documento (in sostituzione alla Data documento):</label>
                        <input
                            type={"number"}
                            id={"annoDoc"}
                            name={"annoDoc"}
                            className={"form-control"}
                            value={annoDoc}
                            onChange={(ev) => setAnnoDoc(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="note" className="form-label">Note:</label>
                        <textarea
                            id={"note"}
                            name={"note"}
                            className={"form-control"}
                            rows={3}
                            value={note}
                            onChange={(ev) => setNote(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-12 mt-4"}>
                        <label className="form-label">Documento:</label>
                        <FilePond
                            files={files}
                            onupdatefiles={setFiles}
                            acceptedFileTypes={[
                                "image/png", "image/jpeg", "image/gif", "image/bmp", "image/svg+xml",
                                "image/heic", "application/pdf"
                            ]}
                            allowFileTypeValidation={true}
                            fileValidateTypeDetectType={(source, type) =>
                                new Promise((resolve) => {
                                    resolve(type);
                                })
                            }
                            allowMultiple={false}
                            allowRevert={true}
                            allowReorder={true}
                            allowImagePreview={true}
                            imagePreviewMaxHeight={200}
                            name="files"
                            labelIdle={
                                'Trascina qui i tuoi documenti o <span class="filepond--label-action">Cerca</span>'
                            }
                            labelInvalidField={'Il campo contiene file non validi'}
                            labelFileWaitingForSize={'In attesa della dimensione'}
                            labelFileSizeNotAvailable={'Dimensione non disponibile'}
                            labelFileLoading={'Caricamento'}
                            labelFileLoadError={'Errore durante il caricamento'}
                            labelFileProcessing={'Caricamento'}
                            labelFileProcessingComplete={'Caricamento completato'}
                            labelFileProcessingAborted={'Caricamento annullato'}
                            labelFileProcessingError={'Errore durante il caricamento'}
                            labelTapToCancel={'tocca per annullare'}
                            labelTapToRetry={'tocca per riprovare'}
                            labelTapToUndo={'tocca per annullare'}
                            labelButtonRemoveItem={'Rimuovi'}
                            labelButtonAbortItemLoad={'Annulla'}
                            labelButtonRetryItemLoad={'Riprova'}
                            labelButtonAbortItemProcessing={'Annulla'}
                            labelButtonUndoItemProcessing={'Annulla'}
                            labelButtonRetryItemProcessing={'Riprova'}
                            labelButtonProcessItem={'Carica'}
                        />
                    </div>
                    <div className={"col-md-12 mt-4"}>
                        <label className="form-label">Anteprima:</label>
                        <FilePond
                            files={anteprime}
                            onupdatefiles={setAnteprime}
                            acceptedFileTypes={[
                                "image/png", "image/jpeg", "application/pdf"
                            ]}
                            allowFileTypeValidation={true}
                            fileValidateTypeDetectType={(source, type) =>
                                new Promise((resolve) => {
                                    resolve(type);
                                })
                            }
                            allowMultiple={false}
                            allowRevert={true}
                            allowReorder={true}
                            allowImagePreview={true}
                            imagePreviewMaxHeight={200}
                            name="anteprime"
                            labelIdle={
                                'Trascina qui i tuoi documenti o <span class="filepond--label-action">Cerca</span>'
                            }
                            labelInvalidField={'Il campo contiene file non validi'}
                            labelFileWaitingForSize={'In attesa della dimensione'}
                            labelFileSizeNotAvailable={'Dimensione non disponibile'}
                            labelFileLoading={'Caricamento'}
                            labelFileLoadError={'Errore durante il caricamento'}
                            labelFileProcessing={'Caricamento'}
                            labelFileProcessingComplete={'Caricamento completato'}
                            labelFileProcessingAborted={'Caricamento annullato'}
                            labelFileProcessingError={'Errore durante il caricamento'}
                            labelTapToCancel={'tocca per annullare'}
                            labelTapToRetry={'tocca per riprovare'}
                            labelTapToUndo={'tocca per annullare'}
                            labelButtonRemoveItem={'Rimuovi'}
                            labelButtonAbortItemLoad={'Annulla'}
                            labelButtonRetryItemLoad={'Riprova'}
                            labelButtonAbortItemProcessing={'Annulla'}
                            labelButtonUndoItemProcessing={'Annulla'}
                            labelButtonRetryItemProcessing={'Riprova'}
                            labelButtonProcessItem={'Carica'}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={isSaving}>
                    <Translate>Chiudi</Translate>
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={!idDocumento && (isSaving || files.length === 0 || !titoloDoc)}>
                    {isSaving ? 'Salvataggio...' : <Translate>Salva</Translate>}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}